
import React, { useEffect, useState, useRef, useContext } from "react";
import { ButtonHeading, CommonModal, CustomPagination } from "components";
import StorageService from "utils/StorageServices/StorageServices";
import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import AddEditSupplier from "modals/AddEditSupplier";
import {
  deleteSupplierData,
  getSupplierListData,
  changeSupplierStatusData,
} from "_services/accountsServices/supplierServices";

import BootstrapTable from "components/BootstrapTable";
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from "modals/MastersFilterModal";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { CiLock, CiUnlock } from "react-icons/ci";

import LoadingBar from "react-top-loading-bar";
import {
  changeUserStatusData,
  deleteRole,
  deleteUserData,
  getRole,
  getUser,
} from "_services";
import { useNavigate } from "react-router-dom";
import { UserContext } from "context";
import RupeeIcon from "pages/User/RupeeIcon";
import { utils } from "helper";
import useDocumentTitle from "hooks/useDocumentTitle";
import './role.css';

const Role = () => {
  useDocumentTitle("Role | T360");

  const navigate = useNavigate();
  const { settingChild } = useContext(UserContext);
  const settingChildRoles = settingChild?.find((i) => i?.label === "Roles");
  const loadingBarRef = useRef(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [userlist, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [statusObject, setStatusObject] = useState(null);
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: "",
    status: 1,
  });
  const [editSupplierData, setEditSupplierData] = useState(null);
  const prevFilterRef = useRef();

  const getDataSupplierList = async () => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
      };
      const res = await getRole(object);
      if (res?.responseCode === 200) {
        setUserList(res.data?.roleDetail);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete();
      }
    }
  };

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      getDataSupplierList();
      prevFilterRef.current = filter;
    }
  }, [filter, showOffcanvas]);

  const deleteHandler = (item) => {
    setIsDelete(item);
  };

  const submitDeleteSupplier = async () => {
    setLoadingDelete(true);
    try {
      loadingBarRef.current?.continuousStart();
      let object = {
        company_id: isDelete?.company_id,
        role_id: isDelete?._id,
      };

      const res = await deleteRole(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataSupplierList();
        setLoadingDelete(false);
        setIsDelete(false);
      } else {
        toast.error("Error !! ");
        setLoadingDelete(false);
      }
    } catch (error) {
      setLoadingDelete(false);
      toast.error(error);
    }
  };

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteSupplier,
    isLoadding: loadingDelete,
  };

  const statusChangeHnadle = async (data, index) => {

    const list = [...userlist];
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        param_user_id: data?.user_id?._id,
        status: data?.active === 1 ? 0 : 1,
      };

      const res = await changeUserStatusData(payload);
      if (res?.responseCode === 200) {
        getDataSupplierList();
      } else {

        setTimeout(() => {
          list[index].active = data?.active === 1 ? 0 : 1;

          setUserList(list);
        }, 500);
      }
    } catch (error) {
    }
  };

  const handleStatusEvent = async (data, index) => {
    statusChangeHnadle(data, index);
    const list = [...userlist];
    list[index].active = data?.active === 1 ? 0 : 1;
    setUserList(list);
  };

  const userEditView = (id) => {
    navigate(`edit/${btoa(id)}`);
  };

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "User Name", accessor: "supplier_name" },
    { header: "Description", accessor: "description" },
    { header: "", accessor: "lock" },
    // { header: "Mobile", accessor: "contact_number" },
    { header: "Actions", accessor: "action" },
  ];

  const RowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: (
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              {!item?.is_lock && (
                <>
                  {settingChildRoles?.view === 1 && (
                    <Link
                      to={`/setting/role/view/${btoa(item?._id)}`}
                      className="_avPointer"
                      style={{ textDecoration: "none" }}
                    >
                      <span className="_samAnchor">
                        <span className="viewIcon_avt">
                          <AiOutlineEye />
                        </span>
                        &nbsp; View
                      </span>
                    </Link>
                  )}
                </>
              )}

              {!item?.is_lock && (
                <>
                  {settingChildRoles?.edit === 1 && (
                    <Link
                      onClick={() => userEditView(item?._id)}
                      className="_avPointer"
                      style={{ textDecoration: "none" }}
                    >
                      <span className="_samAnchor">
                        <span className="viewIcon_avt">
                          <FiEdit />
                        </span>
                        &nbsp; Edit
                      </span>
                    </Link>
                  )}
                </>
              )}
              {/* <div
                  
                  className='_avPointer'
                >
                  <span className='_samAnchor'>
                    <span className='editIcon_avt'>
                      <FiEdit />
                    </span>
                    Edit
                  </span>
                </div> */}

              {!item?.is_lock && (
                <>
                  {settingChildRoles?.delete === 1 && (
                    <div
                      onClick={(e) => deleteHandler(item)}
                      className="_avPointer"
                    >
                      <span className="_samAnchor">
                        <span className="deleteIcon_avt">
                          <FaRegTrashCan color="red" />
                        </span>
                        Delete
                      </span>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </React.Fragment>
      ),
      lock: (
        <>
          {" "}
          {item?.is_lock == 1 && (
            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                color: "#1450ec",
              }}
            >
              <span>
                <CiLock color="red" size={20} />

              </span>
            </div>
          )}
          {item?.is_lock !== 1 && (
            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                color: "#1450ec",
              }}
            >
              <span>
                <CiUnlock color="green" size={20} />

              </span>
            </div>
          )}
        </>
      ),
      description: (
        <>{item?.description ? utils.spliceString(item?.description, 0, 40) : ''}</>
      ),
      supplier_name: (
        // <Link style={{ textDecoration: 'none' }}>
        //   {item?.company_user_name ? item?.company_user_name : '-'}
        // </Link>
        <Link
          style={{ textDecoration: "none" }}
          to={`/setting/role/view/${btoa(item?._id)}`}
        >
          {item?.role_name}
        </Link>
      ),
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          {!item?.is_lock && (
            <>
              {settingChildRoles?.view === 1 && (
                <Link
                  to={`/setting/role/view/${btoa(item?._id)}`}
                  className="_avPointer"
                  style={{ textDecoration: "none" }}
                >
                  <span className="_samAnchor">
                    <span className="viewIcon_avt">
                      <AiOutlineEye color="green" />
                    </span>
                    &nbsp;
                  </span>
                </Link>
              )}
            </>
          )}

          {!item?.is_lock && (
            <>
              {settingChildRoles?.edit === 1 && (
                <Link
                  onClick={() => userEditView(item?._id)}
                  className="_avPointer"
                  style={{ textDecoration: "none" }}
                >
                  <span className="_samAnchor">
                    <span className="viewIcon_avt">
                      <FiEdit color="blue" />
                    </span>
                    &nbsp;
                  </span>
                </Link>
              )}
            </>
          )}
          {/* <div
                  
                  className='_avPointer'
                >
                  <span className='_samAnchor'>
                    <span className='editIcon_avt'>
                      <FiEdit />
                    </span>
                    Edit
                  </span>
                </div> */}

          {!item?.is_lock && (
            <>
              {settingChildRoles?.delete === 1 && (
                <div
                  onClick={(e) => deleteHandler(item)}
                  className="_avPointer"
                >
                  <span className="_samAnchor">
                    <span className="deleteIcon_avt">
                      <FaRegTrashCan color="red" />
                    </span>

                  </span>
                </div>
              )}
            </>
          )}
        </div>
      )

    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }));
  };

  return (
    <div className="__profilCmp_main setting-nw-parentBx">
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />
      <ButtonHeading
        title={"Role"}
        className="commonHeading_title"
        onClick={() => navigate("/setting/role/addrole")}
        buttonTitle={settingChildRoles?.create === 1 && "Add Role"}
        showSearchFilter={{
          search: true,
          filterOption: true,
          filterCount: true,
        }}
        onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
        filter={filter}
        setFilter={setFilter}
        isDebouncedSearch={true}
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          tableClass="nrml-tbl"
          columns={columns}
          data={RowListData(userlist?.length > 0 ? userlist : [])}
          isLoading={loading}
        />

        {userlist?.length > 0 && (
          <div className="paginationFt_avt ">
            <CustomPagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={filter.offset}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
      >
        {showOffcanvas && (
          <AddEditSupplier
            isOpen={showOffcanvas}
            onClose={() => setShowOffcanvas(false)}
            supplierData={editSupplierData}
            hideAddNewOption={false}
          />
        )}
      </div>

      <div className={showOffcanvas ? "offBack_drop" : ""}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {isDelete?.company_id && (
        <CommonModal {...propsObject}>
          <p className="p-3"> Are you sure you want to delete {isDelete?.name} ?</p>
        </CommonModal>
      )}
    </div>
  );
};

export default Role;
